export enum PORTALTYPE {
    SCHOOL = 'school',
    TEACHER = 'teacher',
    PARENT = 'parent',
    CUSTOMER = 'customer',
    DRIVER = 'driver',
};